import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/nursecarecore/user");

/**
 * 按角色查用户
 * @param arg
 * @returns {*}
 */
function findByRolesAsync(arg) {
    return remoteCall.invoke("findByRoles", arg);
}

// 更新主科室
function updatePrimaryUnitAsync(arg) {
    return remoteCall.invoke("updatePrimaryUnit", arg);
}

function updatePrimaryUnitBatchAsync(arg) {
    return remoteCall.invoke("updatePrimaryUnitBatch", arg);
}

// 设置人员类型
function updateUserTypeAsync(arg) {
    return remoteCall.invoke("updateUserType", arg);
}

function findUserByTextAsync(param) {
    return remoteCall.invoke("findUserByText", param);
}

function findUserAsync(param) {
    return remoteCall.invoke("findUser", param);
}

function addUserUnitAsync(param) {
    return remoteCall.invoke("addUserUnit", param);
}

function deleteUserUnitAsync(param) {
    return remoteCall.invoke("deleteUserUnit", param);
}

function updateUsersAsync(param) {
    return remoteCall.invoke("updateUsers", param);
}

function findUserByRoleTypeAsync(param) {
    return remoteCall.invoke("findUserByRoleType", param);
}

function addWorkUnitAsync(param) {
    return remoteCall.invoke("addWorkUnit", param);
}

function listWorkUnitProfileAsync(param) {
    return remoteCall.invoke("listWorkUnitProfile", param);
}

function updateUserWorkUnitAsync(param) {
    return remoteCall.invoke("updateUserWorkUnit", param);
}

function addUsersAsync(param) {
    return remoteCall.invoke("addUsers", param);
}

function deleteUsersAsync(param) {
    return remoteCall.invoke("deleteUsers", param);
}

function clearMobileAsync(param) {
    return remoteCall.invoke("clearMobile", param);
}

function listUnitProfileAsync(param) {
    return remoteCall.invoke("listUnitProfile", param);
}

function findUserByRoleIdAsync(param) {
    return remoteCall.invoke("findUserByRoleId", param);
}

function updateCodeAsync(param) {
    return remoteCall.invoke("updateCode", param);
}

function updateUserAsync(param) {
    return remoteCall.invoke("updateUser", param);
}

export default {
    findUserByTextAsync,
    findUserAsync,
    findByRolesAsync,
    updatePrimaryUnitAsync,
    updateUserTypeAsync,
    addUserUnitAsync,
    deleteUserUnitAsync,
    updatePrimaryUnitBatchAsync,
    updateUsersAsync,
    findUserByRoleTypeAsync,
    addWorkUnitAsync,
    listWorkUnitProfileAsync,
    updateUserWorkUnitAsync,
    addUsersAsync,
    deleteUsersAsync,
    clearMobileAsync,
    listUnitProfileAsync,
    findUserByRoleIdAsync,
    updateCodeAsync,
    updateUserAsync,
};
